import { useEffect, createRef, useState } from 'react'
import useMapStore from '../stores/useMapStore'
import { ElementRef, LocationType, ExtentType } from '../stores/types/useMapStoreType'
import Point from '@arcgis/core/geometry/Point'

const useMap = () => {
    const mapStore = useMapStore()
    const refElementMap = createRef<HTMLDivElement>()
    const refElementBasemapGallery = createRef<HTMLDivElement>()
    const refComponentBottomRight = createRef<HTMLDivElement>()
    const refElementLocationRealtime = createRef<HTMLDivElement>()

    const [locationExtent, setLocationExtent] = useState<ExtentType>()

    useEffect(() => {
        loadMap()
    }, [])

    const loadMap = async () => {
        const elementRef: ElementRef = {
            elementDiv: refElementMap.current ?? undefined,
            elementBasemapGallery: refElementBasemapGallery.current ?? undefined,
            componentBottomRight: refComponentBottomRight.current ?? undefined,
        }
        mapStore.createMap(elementRef)
    }

    const selectSketchTool = (tool: string) => {
        mapStore._view.when(() => {
            mapStore.addSketchViewModel(tool)
        })
    }

    const getExtentMapView = () => {
        const { xmax, xmin, ymax, ymin } = mapStore._view.extent
        setLocationExtent({ xmax, xmin, ymax, ymin })
    }

    const zoomToPoint = (param: LocationType) => {
        const { latitude, longitude } = param
        if (latitude && longitude) {
            mapStore._map.removeAll()

            const pt = new Point({
                latitude,
                longitude,
            })

            mapStore._view
                .goTo({
                    center: [pt],
                    zoom: 17,
                })
                .then(() => {
                    getExtentMapView()
                })

            mapStore.createPoint(param)
        }
    }

    return {
        refElementMap,
        refElementBasemapGallery,
        refComponentBottomRight,
        refElementLocationRealtime,
        selectSketchTool,
        zoomToPoint,
    }
}

export default useMap
